
export default function Hero() {
  return (
    <section id="anasayfa" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/9758a837643640461d83b825e105fc00.jpg"
          alt="Yıldırım Reklam Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black/70"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 text-center w-full">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
            Ankara'nın En <span className="text-red-600">Kaliteli</span> ve <span className="text-red-600">Ucuz</span> Branda Çözümleri
          </h1>
          <p className="text-xl md:text-2xl text-gray-200 mb-8 leading-relaxed">
            Profesyonel baskı hizmetleri ile markanızı öne çıkarın. Yüksek kalite, uygun fiyat ve hızlı teslimat garantisi.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a 
              href="#iletisim" 
              className="bg-red-600 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-red-700 transition-all transform hover:scale-105 shadow-xl whitespace-nowrap cursor-pointer"
            >
              Hemen Teklif Alın
            </a>
            <a 
              href="tel:+908503073704" 
              className="bg-white text-red-600 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-gray-100 transition-all transform hover:scale-105 shadow-xl whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-fill mr-2"></i>
              Bizi Arayın
            </a>
          </div>
          
          {/* Features */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-16">
            <div className="bg-white/10 backdrop-blur-md rounded-xl p-6 border border-white/20">
              <div className="w-14 h-14 bg-red-600 rounded-lg flex items-center justify-center mx-auto mb-4">
                <i className="ri-medal-fill text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-white mb-2">Yüksek Kalite</h3>
              <p className="text-gray-200">Premium malzemeler ve son teknoloji baskı sistemleri</p>
            </div>
            <div className="bg-white/10 backdrop-blur-md rounded-xl p-6 border border-white/20">
              <div className="w-14 h-14 bg-red-600 rounded-lg flex items-center justify-center mx-auto mb-4">
                <i className="ri-price-tag-3-fill text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-white mb-2">Uygun Fiyat</h3>
              <p className="text-gray-200">Ankara'nın en rekabetçi fiyatları ile hizmetinizdeyiz</p>
            </div>
            <div className="bg-white/10 backdrop-blur-md rounded-xl p-6 border border-white/20">
              <div className="w-14 h-14 bg-red-600 rounded-lg flex items-center justify-center mx-auto mb-4">
                <i className="ri-time-fill text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-white mb-2">Hızlı Teslimat</h3>
              <p className="text-gray-200">Zamanında ve güvenli teslimat garantisi</p>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
    </section>
  );
}
